<template>
    <div id="notFound">
        <span>404</span>
    </div>
</template>
<script>
export default {
    name:'notFound',
}
</script>